import React, { useEffect, useState } from "react";
import Layout from "../../layouts/Layout";
import {
    changeretatoperateur,
    rechercheroperateurparpays,
    rechercheroperateurs,
} from "../../services/parametres/operateur";
import { rechercherpays, supprimerpays } from "../../services/parametres/pays";
import AjouPays from "./AjouPays";
import AjoutOperateur from "./AjoutOperateur";
import { Oval } from "react-loader-spinner";
import AjoutCommission from "./AjoutCommission";
import { rechercherallcommission } from "../../services/parametres/commission";
import AjoutAffichage from "./AjoutAffichage";
import { rechercherallprestataires } from "../../services/prestataires/prestatairesRequest";
import { useTranslation } from "react-i18next";

function Parametres() {
    const { t } = useTranslation();
    const [ongletActif, setongletActif] = useState({
        pays: true,
        operateur: false,
        commission: false,
        affichage: false,
    });
    const [listePays, setlistePays] = useState([]);
    const [listeOperateur, setlisteOperateur] = useState([]);
    const [listeCommission, setlisteCommission] = useState([]);
    const [infoOperateur, setinfoOperateur] = useState({});
    const [infoCommission, setinfoCommission] = useState({});
    const [infoAffichage, setinfoAffichage] = useState({});
    const [loading, setloading] = useState(false);
    const [listePrestataires, setlistePrestataires] = useState([]);

    const hangleOngletActif = (val) => {
        if (val === 1) {
            setongletActif({
                pays: true,
                operateur: false,
                commission: false,
                affichage: false,
            });
        } else if (val === 2) {
            setongletActif({
                pays: false,
                operateur: true,
                commission: false,
                affichage: false,
            });
        } else if (val === 3) {
            setongletActif({
                pays: false,
                operateur: false,
                commission: true,
                affichage: false,
            });
        } else if (val === 4) {
            setongletActif({
                pays: false,
                operateur: false,
                commission: false,
                affichage: true,
            });
        }
    };

    //Affiche des pays
    const afficherPays = () => {
        setloading(true);
        rechercherpays()
            .then((res) => {
                setloading(false);
                setlistePays(res.data.donnee);
            })
            .catch(() => {
                setloading(false);
            });
    };

    //Affichage des opérateurs
    const afficherOperateurs = () => {
        setloading(true);
        rechercheroperateurs()
            .then((res) => {
                setloading(false);
                setlisteOperateur(res.data.donnee);
            })
            .catch((error) => {
                setloading(false);
                console.log(error.response.data);
            });
    };

    const affichercommission = () => {
        setloading(true);
        rechercherallcommission()
            .then((res) => {
                setloading(false);
                setlisteCommission(res.data.donnee || res.data || []);
            })
            .catch(() => {
                setloading(false);
            });
    };

    //Changement d'état de l'opérateur
    const handleStatut = (code) => {
        changeretatoperateur(code).then((res) => {
            afficherOperateurs();
        });
    };

    const handleSuppressionPays = (id) => {
        supprimerpays(id).then((res) => {
            afficherPays();
        });
    };

    const filterOnPays = (e, type) => {
        setloading(true);
        if (type === "COMMISSION") {
            rechercherallcommission({ pays_id: e.target.value })
                .then((res) => {
                    setloading(false);
                    setlisteCommission(res.data.donnee);
                })
                .catch(() => {
                    setloading(false);
                });
        } else if (type === "OPERATEUR") {
            if (e.target.value !== "") {
                rechercheroperateurparpays(e.target.value)
                    .then((res) => {
                        setloading(false);
                        setlisteOperateur(res.data.donnee);
                    })
                    .catch((error) => {
                        setloading(false);
                        console.log(error.response.data);
                    });
            } else {
                afficherOperateurs();
            }
        }
    };

    const afficherPrestataires = () => {
        rechercherallprestataires().then((res) => {
            setlistePrestataires(res.data.donnee);
        });
    };

    useEffect(() => {
        afficherPays();
        afficherOperateurs();
        affichercommission();
        afficherPrestataires();
        if (localStorage.getItem("role") === "ROLE_ADMIN") {
            setongletActif({
                pays: true,
                operateur: false,
                commission: false,
                affichage: false,
            });
        } else {
            setongletActif({
                pays: false,
                operateur: false,
                commission: false,
                affichage: true,
            });
        }
    }, []);

    const optionListePays = listePays.map((item, index) => (
        <option key={index} value={item.id}>
            {item.designation}
        </option>
    ));

    const rowlistPays = listePays.map((item) => (
        <tr key={item.id}>
            <td>
                <h4 className="ui image header">
                    <img
                        src={
                            "https://www.drapeauxdespays.fr/data/flags/w702/" +
                            item.id.toLowerCase() +
                            ".png"
                        }
                        className="ui mini rounded image"
                    />
                    <div className="content">{item.designation}</div>
                </h4>
            </td>
            <td>{item.id}</td>
            <td>
                <a
                    onClick={() => handleSuppressionPays(item.id)}
                    className="text-center text-danger"
                >
                    {" "}
                    <i className="fa fa-trash-alt"></i>
                </a>
            </td>
        </tr>
    ));

    const rowListOperateur = listeOperateur.map((item) => (
        <tr key={item.id}>
            <td>
                <h4 className="ui image header">
                    <img
                        src={
                            "https://www.drapeauxdespays.fr/data/flags/w702/" +
                            item.pays[0].id.toLowerCase() +
                            ".png"
                        }
                        className="ui mini rounded image"
                    />
                    <div className="content">{item.pays[0].designation}</div>
                </h4>
            </td>
            <td>{item.id}</td>
            <td>{item.designation}</td>
            <td>{item.classeTraitement}</td>
            <td>
                <button
                    type="button"
                    onClick={() => handleStatut(item.id)}
                    className="btn btn-md"
                >
                    {item.typeEtat === "ACTIF" ? (
                        <span className="btn text-success">
                            <i className="fa fa-sign-in-alt"></i> {t('settings.operators.active')}
                        </span>
                    ) : (
                        <span className="btn text-danger">
                            {" "}
                            <i className="fa fa-ban"></i> {t('settings.operators.inactive')}
                        </span>
                    )}
                </button>
                <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#ajoutoperateur"
                    onClick={() => setinfoOperateur(item)}
                    className="btn btn-md"
                >
                    <i className="fa fa-pencil-alt"></i>
                </button>
            </td>
        </tr>
    ));

    const rowListCommission =
        listeCommission.length > 0 &&
        listeCommission.map((item, index) => (
            <tr key={index}>
                <td>
                    {" "}
                    {item.pays !== null && (
                        <h4 className="ui image header">
                            <img
                                src={
                                    "https://www.drapeauxdespays.fr/data/flags/w702/" +
                                    item.pays.id.toLowerCase() +
                                    ".png"
                                }
                                className="ui mini rounded image"
                            />
                            <div className="content">{item.pays.designation}</div>
                        </h4>
                    )}
                </td>
                <td>
                    {item.operateurmobilemoney !== undefined && (
                        <span>{item.operateurmobilemoney.designation}</span>
                    )}
                </td>
                <td>{item.typeCommission}</td>
                <td>{item.valeur}</td>
                <td>
                    <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#ajoutcommission"
                        onClick={() => setinfoCommission(item)}
                        className="btn btn-md"
                    >
                        <i className="fa fa-pencil-alt"></i>
                    </button>
                </td>
            </tr>
        ));

    const rowListAffichage =
        listePrestataires.length > 0 &&
        listePrestataires.map((item, index) => (
            <tr key={index}>
                <td>{item.nom}</td>
                <td>{item.mode}</td>
                <td>
                    <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#ajoutaffichage"
                        onClick={() => setinfoAffichage(item)}
                        className="btn btn-md"
                    >
                        <i className="fa fa-pencil-alt"></i>
                    </button>
                </td>
            </tr>
        ));

    return (
        <Layout>
            <ul className="nav nav-tabs">
                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                    <li className="nav-item">
                        <a
                            className={
                                ongletActif.pays ? "nav-link active text-white" : "nav-link"
                            }
                            onClick={() => hangleOngletActif(1)}
                        >
                            {t('settings.tabs.countries')}
                        </a>
                    </li>
                )}
                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                    <li className="nav-item">
                        <a
                            className={
                                ongletActif.operateur
                                    ? "nav-link active text-white"
                                    : "nav-link"
                            }
                            onClick={() => hangleOngletActif(2)}
                        >
                            {t('settings.tabs.operators')}
                        </a>
                    </li>
                )}
                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                    <li className="nav-item">
                        <a
                            className={
                                ongletActif.commission
                                    ? "nav-link active text-white"
                                    : "nav-link"
                            }
                            onClick={() => hangleOngletActif(3)}
                        >
                            {t('settings.tabs.commission')}
                        </a>
                    </li>
                )}
                <li className="nav-item">
                    <a
                        className={
                            ongletActif.affichage ? "nav-link active text-white" : "nav-link"
                        }
                        onClick={() => hangleOngletActif(4)}
                    >
                        {t('settings.tabs.displayMode')}
                    </a>
                </li>
            </ul>

            {ongletActif.pays && (
                <div className="mt-3">
                    <div className="d-flex justify-content-between">
                        <div className="fw-bold">
                            <legend className="fw-bold">{t('settings.countries.title')}</legend>
                        </div>
                        <div className="d-flex">
                            <div>
                                <a
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#ajoutPays"
                                    className="btn colorYelloSkanPay text-black btn-md"
                                >
                                    {" "}
                                    <i className="fa fa-plus-circle"></i> {t('settings.countries.newCountry')}
                                </a>
                                <AjouPays afficherPays={afficherPays} />
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive mt-4">
                        <table className="table table-bordered celled padded">
                            <thead>
                                <tr>
                                    <th>{t('settings.countries.title')}</th>
                                    <th width="15%">{t('settings.countries.countryCode')}</th>
                                    <th width="15%">{t('settings.countries.quickAction')}</th>
                                </tr>
                            </thead>
                            <tbody>{rowlistPays}</tbody>
                        </table>
                    </div>
                    {loading && (
                        <div className="d-flex justify-content-center">
                            <Oval width={30} height={30} color="#344b7b" visible={loading} />
                        </div>
                    )}
                </div>
            )}

            {
                //Opérateurs
                ongletActif.operateur && (
                    <div className="mt-3">
                        <div className="d-flex justify-content-between">
                            <div className="fw-bold">
                                <legend className="fw-bold">{t('settings.operators.title')}</legend>
                            </div>
                            <div className="d-flex">
                                <div className="mx-3">
                                    <select
                                        onChange={(e) => filterOnPays(e, "OPERATEUR")}
                                        className="form-select form-select-md"
                                        aria-label=".form-select-md example"
                                    >
                                        <option value="">{t('settings.operators.selectCountry')}</option>
                                        {optionListePays}
                                    </select>
                                </div>

                                <div>
                                    <a
                                        type="button"
                                        onClick={() => setinfoOperateur({})}
                                        data-bs-toggle="modal"
                                        data-bs-target="#ajoutoperateur"
                                        className="btn colorYelloSkanPay text-black btn-md"
                                    >
                                        {" "}
                                        <i className="fa fa-plus-circle"></i> {t('settings.operators.newOperator')}
                                    </a>
                                    <AjoutOperateur
                                        data={infoOperateur}
                                        afficherOperateurs={afficherOperateurs}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive mt-4">
                            <table className="table table-bordered celled padded">
                                <thead>
                                    <tr>
                                        <th>{t('settings.countries.title')}</th>
                                        <th>{t('settings.operators.code')}</th>
                                        <th>{t('settings.operators.operator')}</th>
                                        <th>{t('settings.operators.processingClass')}</th>
                                        <th width="15%">{t('settings.operators.quickAction')}</th>
                                    </tr>
                                </thead>
                                <tbody>{rowListOperateur}</tbody>
                            </table>
                        </div>
                        {loading && (
                            <div className="d-flex justify-content-center">
                                <Oval
                                    width={30}
                                    height={30}
                                    color="#344b7b"
                                    visible={loading}
                                />
                            </div>
                        )}
                    </div>
                )
            }

            {ongletActif.commission && (
                <div className="mt-3">
                    <div className="d-flex justify-content-between">
                        <div className="fw-bold">
                            <legend className="fw-bold">{t('settings.commission.title')}</legend>
                        </div>
                        <div className="d-flex">
                            <div className="mx-3">
                                <select
                                    onChange={(e) => filterOnPays(e, "COMMISSION")}
                                    className="form-select form-select-md"
                                    aria-label=".form-select-md example"
                                >
                                    <option value="">{t('settings.commission.selectCountry')}</option>
                                    {optionListePays}
                                </select>
                            </div>
                            <div>
                                <a
                                    type="button"
                                    onClick={() => setinfoCommission({})}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ajoutcommission"
                                    className="btn colorYelloSkanPay text-black  btn-md"
                                >
                                    {" "}
                                    <i className="fa fa-plus-circle"></i> {t('settings.commission.newCommission')}
                                </a>
                                <AjoutCommission
                                    data={infoCommission}
                                    affichercommission={affichercommission}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive mt-4">
                        <table className="table table-bordered celled padded">
                            <thead>
                                <tr>
                                    <th>{t('settings.commission.country')}</th>
                                    <th>{t('settings.commission.operator')}</th>
                                    <th>{t('settings.commission.commissionType')}</th>
                                    <th>{t('settings.commission.value')}</th>
                                    <th width="15%">{t('settings.commission.quickAction')}</th>
                                </tr>
                            </thead>
                            <tbody>{rowListCommission}</tbody>
                        </table>
                    </div>
                    {loading && (
                        <div className="d-flex justify-content-center">
                            <Oval width={30} height={30} color="#344b7b" visible={loading} />
                        </div>
                    )}
                </div>
            )}

            {ongletActif.affichage && (
                <div className="mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="fw-bold">
                            <legend className="fw-bold">{t('settings.displayMode.title')}</legend>
                        </div>
                        {localStorage.getItem("role") === "ROLE_ADMIN" && (
                            <div className="d-flex">
                                <div className="">
                                    <select
                                        className="form-select form-select-md"
                                        aria-label=".form-select-md example"
                                    >
                                        <option value="">{t('settings.displayMode.selectProvider')}</option>
                                        {listePrestataires.map((prestataire) => (
                                            <option key={prestataire.id} value={prestataire.id}>
                                                {prestataire.nom}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        <AjoutAffichage
                            data={infoAffichage}
                            afficheraffichage={afficherPrestataires}
                        />
                    </div>

                    <div className="table-responsive mt-4">
                        <table className="table table-bordered celled padded">
                            <thead>
                                <tr>
                                    <th>{t('settings.displayMode.provider')}</th>
                                    <th>{t('settings.displayMode.mode')}</th>
                                    <th width="15%">{t('settings.displayMode.quickAction')}</th>
                                </tr>
                            </thead>
                            <tbody>{rowListAffichage}</tbody>
                        </table>
                    </div>
                    {loading && (
                        <div className="d-flex justify-content-center">
                            <Oval width={30} height={30} color="#344b7b" visible={loading} />
                        </div>
                    )}
                </div>
            )}
        </Layout>
    );
}

export default Parametres;
